import { MCC_GROUP } from '@klopotun/domain';
import { z } from 'zod';
import { booleanQueryParamSchema, isoTimestampSchema, optionalTextSchema, SMALLINT_MAX, uuidSchema, } from './common.js';
const sortOrderSchema = z.int().min(0).max(SMALLINT_MAX);
export const mccGroupSchema = z.enum(MCC_GROUP);
const categoryBodyShape = {
    name: z.string().min(1),
    emoji: optionalTextSchema,
    color: optionalTextSchema,
    sortOrder: sortOrderSchema,
};
export const categorySchema = z.object({
    id: uuidSchema,
    ...categoryBodyShape,
    systemKey: mccGroupSchema.nullable(),
    isArchived: z.boolean(),
    createdAt: isoTimestampSchema,
    updatedAt: isoTimestampSchema,
});
export const categoryListSchema = z.array(categorySchema);
const categoryBodySchema = z.object(categoryBodyShape);
export const createCategoryBodySchema = categoryBodySchema;
export const updateCategoryBodySchema = categoryBodySchema;
export const listCategoriesQuerySchema = z.object({
    includeArchived: booleanQueryParamSchema.default(false),
});
//# sourceMappingURL=category.js.map